import { type PrioritizedRoute } from '../../common';

export function compareRoutePriority(routeA: PrioritizedRoute, routeB: PrioritizedRoute): number {
  return (routeA.priorityOrder ?? Infinity) - (routeB.priorityOrder ?? Infinity);
}
